// Copyright (c) 2019 Shellyl_N and Authors
// license: ISC
// https://github.com/shellyln
export class ParseError extends Error {
}
export function parserInput(src, context) {
    return ({
        src,
        start: 0,
        end: src.length,
        context: context,
    });
}
//# sourceMappingURL=types.js.map